export enum ResourceFileTarget {
    HOME = 'home',
    GALLERY = 'gallery'
}